// i18n
import 'src/locales/i18n'

// scrollbar
import 'simplebar-react/dist/simplebar.min.css'

// lightbox
import 'yet-another-react-lightbox/styles.css'
import 'yet-another-react-lightbox/plugins/captions.css'
import 'yet-another-react-lightbox/plugins/thumbnails.css'

// map
import 'mapbox-gl/dist/mapbox-gl.css'

// editor
import 'react-quill/dist/quill.snow.css'

// carousel
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

// image
import 'react-lazy-load-image-component/src/effects/blur.css'

// config
import './Config'

// ----------------------------------------------------------------------

// routes
import Router from 'src/routes/sections'
// theme
import ThemeProvider from 'src/theme'
// locales
import { LocalizationProvider } from 'src/locales'
// hooks
import { useScrollToTop } from 'src/hooks/use-scroll-to-top'
// components
import ProgressBar from 'src/components/progress-bar'
import { MotionLazy } from 'src/components/animate/motion-lazy'
import SnackbarProvider from 'src/components/snackbar/snackbar-provider'
import { SettingsProvider, SettingsDrawer } from 'src/components/settings'
// auth
import { AuthProvider, AuthConsumer } from 'src/auth/context/jwt'
import { StompSessionProvider } from 'react-stomp-hooks'
import { Snackbar } from './components/snackbar'

// ----------------------------------------------------------------------

export default function App() {
  useScrollToTop()

  const { REACT_APP_NOTIFICATION_SOCKET } = process.env

  return (
    <StompSessionProvider url={`${REACT_APP_NOTIFICATION_SOCKET}`}>
      <AuthProvider>
        <LocalizationProvider>
          <SettingsProvider
            defaultSettings={{
              themeMode: 'dark', // 'light' | 'dark'
              themeDirection: 'ltr', //  'rtl' | 'ltr'
              themeContrast: 'default', // 'default' | 'bold'
              themeLayout: 'vertical', // 'vertical' | 'horizontal' | 'mini'
              themeColorPresets: 'default', // 'default' | 'cyan' | 'purple' | 'blue' | 'orange' | 'red'
              themeStretch: true, // false = applica maxWidth
            }}
          >
            <ThemeProvider>
              <MotionLazy>
                <SnackbarProvider>
                  <SettingsDrawer />
                  <ProgressBar />
                  <Snackbar />
                  <AuthConsumer>
                    <Router />
                  </AuthConsumer>
                </SnackbarProvider>
              </MotionLazy>
            </ThemeProvider>
          </SettingsProvider>
        </LocalizationProvider>
      </AuthProvider>
    </StompSessionProvider>
  )
}
